/* eslint-disable */
"use strict";
import WebSocketActions from './WebSocketRedux'
import AuthActions from './AuthRedux'
import OrderActions from './OrderRedux'
import MessagesActions from './MessagesRedux'

import API from '../Services/Api'
import FixtureAPI from '../Services/FixtureApi'
import DebugConfig from '../Config/DebugConfig'

import NotificationManager from '../Lib/NotificationManager'


const WebSocketMiddleware = (function () {
  var socket = null, connecting = false, closing = false
  let api = DebugConfig.useFixtures ? FixtureAPI : API.create()

   let keepAlive = setInterval(function() {
     
     if (socket && (socket.readyState !== WebSocket.CONNECTING)) {
        socket.send("keepAlive")
        console.log("WEBSOCKET keepAlive")
     }
     else console.log("WEBSOCKET no socket, no keepAlive")
   }, 50000)

  const close = (socket) => {
    console.log('***caution, closing web socket')
    if (socket != null) {
      closing = true
      connecting = false
      socket.close()

      socket = null
    }
  }
  const onOpen = (socket, store, token) => event => {
    console.log("WEBSOCKET onOpen")
    connecting = false
    socket.send('auth: ' + token)
    store.dispatch(WebSocketActions.connected(token))
  }
  const onClose = (socket, store) => event => {
    console.log("WEBSOCKET onClose event = " + JSON.stringify(event, null, 2))
    closing = false
    store.dispatch(WebSocketActions.disconnected(event))
  }
  const IsOpenChat = ({ UserNames : EventUsernames, typing : Typing}, StateUsernames, { UserId : PhoneUserId, Username : PhoneUsername }, Opponent) => {
    console.tron.display({name: 'OfflineMsg',preview: "IsOpenChat",value: {EventUsernames: EventUsernames, StateUsernames: StateUsernames, Typing: Typing, PhoneUserId: PhoneUserId, Opponent: Opponent}})
    console.log("in IsOpenChat StateUsernames = " + JSON.stringify(StateUsernames))
    if( typeof StateUsernames === 'undefined' ) {
      // this is happening after returning from background
      console.log("returning IsOpenChat false location 1")
      return false
    }
    if( Typing === PhoneUserId || (Typing && Typing !== Opponent) ) {
      console.log("returning IsOpenChat false location 2")
      return false
    }
    const foundInState = Username => StateUsernames.indexOf(Username) !== -1

    let output = EventUsernames.filter(foundInState).length > 0
    console.log("returning IsOpenChat " + output + " location 3")
    return output // EventUsernames.filter(foundInState).length > 0
  }
  const onMessage = (socket, store) => event => {
    console.log("!!! onMessage event = " + JSON.stringify(event, null, 2))
    let state = store.getState( )

    const orderDetails = ( sockEvent ) => {
      const details = sockEvent.Details
      const self = state.auth.user.UserId
      const isGoeFundMe = details.TagKind == 'FundMe'
      console.log("order details = " + JSON.stringify(details))
      if (isGoeFundMe && state.auth.muteFunRaised) { // don't show dialog on Stream screen
        const changes = {
          streamingFunRaisedDetails: {
            OrderId: details.OrderId,
            UserId: details.PurchaserUserId,
            Username: details.PurchaserUsername,
          }
        }
        console.log("order details changes " + JSON.stringify(changes))
        store.dispatch(AuthActions.setInfo(changes))
        return null
      }
      
      let AvatarId = ''
      if( details.SellerUserId && details.SellerUserId == self )
        AvatarId = details.PurchaserUserId
      else if( details.PurchaserUserId && details.PurchaserUserId == self )
        AvatarId = details.SellerUserId
      else if( details.EndorserUserId && details.EndorserUserId == self )
        AvatarId = details.SellerUserId

      return { Time : Date.now( ), OrderId : details.OrderId
             , Message : details.Message, UserId : AvatarId, TagKind: details.TagKind}
    }

    if (event.data) {
      var sockEvent = JSON.parse(event.data)
      //console.log("before calling isOpenChat, state.message = " + JSON.stringify(state.message))
      //console.log("before calling isOpenChat, state.message keys = " + JSON.stringify(Object.keys(state.message))) // message.Usernames seems to exist
      //console.log("before calling isOpenChat, sockEvent = " + JSON.stringify(sockEvent))
      //console.log("before calling isOpenChat, state.auth.user = " + state.auth.user)
      //console.log("before calling isOpenChat, state.message.Usernames = " + state.message.Usernames)
      // 2nd arg:  coming back from background, state.message.Usernames is undefined, so we pull from socket event if that is the case
      const isOpenChat = IsOpenChat(sockEvent, state.message.Usernames || sockEvent.Usernames, state.auth.user, state.message.Opponent)
      const details = sockEvent.Details ? sockEvent.Details : null
      // console.log(`WebSocketMiddleware onMessage operation: ${sockEvent.Operation}`)
      switch (sockEvent.Operation) {
        case 'message':
          // "a1526063975.902303 horusscope Ks57589c4d0295a40001ac1f18a31a9d horusscopec zapjqbaRCgZan6 ..."
          var msg = sockEvent.Message.split(' ')
          msg.push(msg.splice(5).join(' '))
          console.log('message: ', msg)
          console.log('is open chat? ', isOpenChat? 'true': 'false')
          if(isOpenChat) {
            store.dispatch(
              MessagesActions.chatMsg
                ({  Time: parseFloat(msg[0].slice(1))
                  , From: msg[1], FromId: msg[2]
                  , Message: msg[5], ToId: msg[4]
                })
            )
          }
          else {
            console.tron.log(`onMessage, !isOpenChat`)
          }
        case 'read':
        case 'delete':
          store.dispatch(MessagesActions.getUnreadMessagesRequest( ))
          store.dispatch(MessagesActions.messagesRequest(null))
          if(isOpenChat && sockEvent.Operation == "delete")
              store.dispatch(MessagesActions.deleteChatSocket({  aTimeStamp : sockEvent.Deleted }) )
          break
        case 'typing':
          if(isOpenChat && state.auth.user && state.auth.user.UserId != sockEvent.Typing)
            store.dispatch(MessagesActions.chatTyping({}))//<>
          break
        case 'order':
          console.log("*** ready to dispatch order sockEvent = " + JSON.stringify(sockEvent, null, 2))
          // this brings up the dialog that says something happened on the order
          const tempOrderDetails = orderDetails(sockEvent)
          if (tempOrderDetails)
            store.dispatch(WebSocketActions.order(tempOrderDetails))
          // also update the Auth store
          if (state.auth.user) {
            const userChanges = sockEvent.Details.Changes
            store.dispatch(AuthActions.authUpdateRequest(userChanges))
          }
          break
        case 'activity':
          if (state.auth.user && state.auth.user.UserId == details.Changes.UserId)
            store.dispatch(AuthActions.authUpdateRequest(details.Changes))
          break;
        case 'coupon':
          if (state.auth.user && state.auth.user.UserId == details.UserId) {
            console.tron.log(`Got a new coupon: ` + JSON.stringify(details))
            // store.dispatch(WebSocketActions.coupon(Object.assign({}, details, {Time : Date.now()})))
            const userChanges = sockEvent.Details.Changes
            store.dispatch(AuthActions.authUpdateRequest(userChanges))
          }
          break;
        case 'goe-fund-me-update':
          console.log(`WebSocketMiddleware goe-fund-me-update, details: ` + JSON.stringify(details))
          if (state.order.postId == details.PostId || !state.order.postId)
            store.dispatch(OrderActions.orderTags(details.PostId))
          break;
        default: break
      }
      console.log('WEBSOCKET ready to dispatch event to websocket') // event is cyclic dont stringify
      store.dispatch(WebSocketActions.message(event))
    }
  }
  // if network is bad, may take a long time to timeout (> 1 minute)
  const onError = (socket, store) => event => {

    // brute force just try a re-init the socket if we get an error of any type
    store.dispatch({ type: 'WEBSOCKET_INIT' })

    console.log("WEBSOCKET error " + Object.keys(event))
    console.log("WEBSOCKET error type " + event.type)
    console.log("WEBSOCKET error type keys " + Object.keys(event.type))
    console.log("WEBSOCKET error type  expanded " + JSON.stringify(event.type))

    // store.dispatch(WebSocketActions.wserr(event)) // caused red screen crash, stack overflow, immutable
  }

  // alternate route to printf that doesnt get removed for test flight build
  //const log = (str) => NotificationManager.postNotificationWithString("AppDelegate_printf", str)
  const log = (str) => {} // normally leave this off when not debugging web sockets to avoid cluttering the console
                          // use above function and name it log for detailed web socket debugging

  return store => next => action => {
    let state = store.getState()
    // Init may be dispatched multiple times
    switch (action.type) {
      case 'WEBSOCKET_INIT':
        log('in WEBSOCKET_INIT case')
        // if -> WebSocket is already authenticating at this moment
        if (connecting) return
        // Check to see if the socket is already open, and close it if so
        log('WEBSOCKET_INIT loc 2')

        close(socket)

        log('WEBSOCKET_INIT loc 3 after close()')

        // Abort if we aren't authenticated in the application
        if (state.auth.username == null) return

        log('WEBSOCKET_INIT loc 4 after check username')
        // Let AppState know we have begun connecting
        connecting = true
        closing = false

        store.dispatch(WebSocketActions.connecting())

        log('WEBSOCKET_INIT loc 5 after dispatch connecting')

        // Get an authentication token
        api.setAuthorization(state.auth.token)

        log('WEBSOCKET_INIT loc 6 after setting auth token ready to get chat token')

        api.chatToken()
          .then(function (response) {

            log('WEBSOCKET_INIT loc 7 after getting chat token')

            if (response) {
              log('WEBSOCKET_INIT loc 7a after new web socket typeof response = ' + typeof response)
              log('WEBSOCKET_INIT loc 7a1 after new web socketresponse = ' + JSON.stringify(response))
            }

            else console.log('WEBSOCKET_INIT 7b no response for api.chatToken call')

            if (response.data) log('WEBSOCKET_INIT loc 7c after new web socket typeof response.data.data = ' + typeof response.data.data)

            log('WEBSOCKET_INIT loc 8 after new web socket response.data = ' + JSON.stringify(response.data))


            if (response.data) log('WEBSOCKET_INIT loc 8a after new web socket typeof response.data.data = ' + typeof response.data.data)

            log("WEBSOCKET_INIT loc 8b ready to call new WebSocket")
            // Initialize the raw underlying WebSocket object
            // this may timeout?
            if (false) { // leave out for web for now
            socket = new WebSocket(response.data.metaData.ChatServerUrl + '/chat')

            log("WEBSOCKET_INIT loc 8c after call new WebSocket")

            socket.onmessage = onMessage(socket, store)
            socket.onclose = onClose(socket, store)
            socket.onopen = onOpen(socket, store, response.data.data[0])
            socket.onerror = onError(socket, store)
            } else {
             console.log("skip web socket conn for web")
             socket = null
            }

          })
          .catch(function (error) {

            log('WEBSOCKET_INIT loc 9 error = ' + error)

            console.log(error)
            connecting = false
            close(socket)
          })
        break
      case 'WEBSOCKET_SEND': if (socket && (socket.readyState !== WebSocket.CONNECTING)) socket.send(action.packet); break
      case 'WEBSOCKET_DISCONNECT': 
        console.log("WEBSOCKET disconnect")
        close(socket); break
      default: return next(action)
    }
  }
})()

export default WebSocketMiddleware
